import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock, ArrowLeft, Sparkles, Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function ComingSoonPage({ feature = '功能', description = '' }) {
 const { t } = useTranslation();
 const navigate = useNavigate();

 return (
 <div className="route-surface coming-soon-page min-h-screen bg-cream-50 flex items-center justify-center p-4">
 <div className="max-w-2xl w-full text-center">
 {/* 返回按钮 */}
 <button
 onClick={() => navigate('/ai-fleet')}
 className="mb-8 inline-flex items-center gap-2 text-ink-600 hover:text-ink-800 transition-colors"
 >
 <ArrowLeft className="w-4 h-4" />
 <span className="text-sm">返回AI车队</span>
 </button>

 {/* 主要内容 */}
 <div className="bg-cream-50 rounded-xl shadow-xl border border-ink-100 p-12 relative overflow-hidden">
 {/* 装饰性背景 */}
 <div className="absolute top-0 right-0 w-64 h-64 bg-accent-100 rounded-full blur-3xl opacity-50 -translate-y-32 translate-x-32"></div>
 <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-100 rounded-full blur-2xl opacity-40 translate-y-24 -translate-x-24"></div>
 
 {/* 图标 */}
 <div className="relative z-10 mb-8">
 <div className="w-24 h-24 bg-gradient-to-br from-accent-400 to-accent-600 rounded-2xl flex items-center justify-center mx-auto shadow-md">
 <Clock className="w-12 h-12 text-white" />
 </div>
 </div>
 
 {/* 标题 */}
 <h1 className="text-4xl font-bold text-accent-600 mb-4 relative z-10">
 {feature} 即将推出
 </h1>
 
 {/* 副标题 */}
 <p className="text-lg text-ink-600 mb-8 leading-relaxed relative z-10">
 {description || `我们正在努力开发 ${feature} 功能，敬请期待！`}
 </p>
 
 {/* 特性预告 */}
 <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10 relative z-10">
 <div className="bg-accent-50 rounded-2xl p-6 border border-accent-200">
 <div className="w-12 h-12 bg-accent-500 rounded-xl flex items-center justify-center mb-4">
 <Sparkles className="w-6 h-6 text-white" />
 </div>
 <h3 className="text-lg font-semibold text-ink-900 mb-2">智能体验</h3>
 <p className="text-sm text-ink-600">基于最新AI技术，提供前所未有的智能体验</p>
 </div>
 
 <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 border border-green-200">
 <div className="w-12 h-12 bg-green-500 rounded-xl flex items-center justify-center mb-4">
 <Zap className="w-6 h-6 text-white" />
 </div>
 <h3 className="text-lg font-semibold text-ink-900 mb-2">极速响应</h3>
 <p className="text-sm text-ink-600">优化算法和基础设施，确保快速响应</p>
 </div>
 </div>
 
 {/* 操作按钮 */}
 <div className="flex flex-col sm:flex-row gap-4 justify-center relative z-10">
 <button
 onClick={() => navigate('/ai-fleet')}
 className="px-8 py-3 bg-gradient-to-r from-accent-500 to-accent-600 text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transform transition-all duration-300"
 >
 体验AI车队
 </button>
 
 <button
 onClick={() => navigate('/shop')}
 className="px-8 py-3 border-2 border-accent-500 text-accent-600 rounded-xl font-semibold hover:bg-accent-50 transition-all duration-300"
 >
 查看产品
 </button>
 </div>
 
 {/* 底部提示 */}
 <div className="mt-8 p-4 bg-cream-100 rounded-2xl relative z-10">
 <p className="text-sm text-ink-500">
 🔔 想要第一时间体验新功能？关注我们的更新通知！
 </p>
 </div>
 </div>
 </div>
 </div>
 );
}